import { Pressable, StyleSheet, View } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import { TRAIL_WINDOW_OPTIONS } from '@/constants/monitor'
import { useTrailSettings } from '@/stores/monitor-store'

export function UserTrailWindowChips() {
    const theme = useTheme()
    const { trailWindow, setTrailWindow } = useTrailSettings()

    return (
        <View style={[styles.row, { backgroundColor: theme.colors.surface }]}>
            <Text variant="labelSmall" style={{ color: theme.colors.onSurfaceVariant }}>
                Trail:
            </Text>
            {TRAIL_WINDOW_OPTIONS.map(option => {
                const isActive = trailWindow === option.value
                return (
                    <Pressable
                        key={option.label}
                        onPress={() => setTrailWindow(option.value)}
                        style={[
                            styles.chip,
                            {
                                backgroundColor: isActive
                                    ? theme.colors.primaryContainer
                                    : theme.colors.surfaceVariant,
                            },
                        ]}
                    >
                        <Text
                            variant="labelMedium"
                            style={{
                                color: isActive
                                    ? theme.colors.onPrimaryContainer
                                    : theme.colors.onSurfaceVariant,
                                fontWeight: isActive ? '600' : '400',
                            }}
                        >
                            {option.label}
                        </Text>
                    </Pressable>
                )
            })}
        </View>
    )
}

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        paddingHorizontal: 16,
        paddingVertical: 10,
    },
    chip: {
        paddingHorizontal: 14,
        paddingVertical: 6,
        borderRadius: 14,
    },
})
